module.exports = __webpack_public_path__ + "static/img/9.9.ddea9aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/9.9.jpg
// module id = aiq6
// module chunks = 0